import { createContext, useState } from "react";
import {
  getFromLocalStorage, setToLocalStorage, removeFromLocalStorage } from "../../lib/localStorage";

const EncryptionContext = createContext();

export function EncryptionContextProvider({ children }) {
    const initialState = getFromLocalStorage("encryption", false);

    const [encryption, setEncryption] = useState(initialState);

    const handleEncryption = () => {
        setToLocalStorage('encryption', !encryption)
        setEncryption(prev => !prev)
    }

    const updateEncryptionStatus = (status, expiration) => {
        setToLocalStorage('encryption', status);
        setToLocalStorage('encryptionExpiration', expiration);
        setEncryption(true);
    }

    const setEncryptionToDefault = () => {
        removeFromLocalStorage('encryption');
        removeFromLocalStorage('encryptionExpiration');
        setEncryption(false);
    }

    const isEncryptionValid = () => {
        const expiration = localStorage.getItem('encryptionExpiration');
        if (expiration) {
            const expirationDate = new Date(expiration);
            const now = new Date();
            if (now > expirationDate) {
                setEncryptionToDefault();
            }
        }
    };

    const valueToShare = {
        handleEncryption,
        encryption,
        setEncryptionToDefault,
        updateEncryptionStatus,
        isEncryptionValid
    }

    return (
        <EncryptionContext.Provider value={valueToShare}>
            {children}
        </EncryptionContext.Provider>
    )
}


export default EncryptionContext